import Seo from "@/components/Seo";
import { FadeUp } from "@/components/Reveal";
import { Eyebrow } from "@/components/shared";

const SECTIONS = [
  {
    title: "1. Use of the Site",
    body: [
      "By accessing or using this website, you agree to be bound by these Terms & Conditions. This site is provided for general informational purposes and to connect visitors with the real estate services of Scherif Real Estate.",
    ],
  },
  {
    title: "2. Real Estate Listings",
    body: [
      "Property information displayed on this site, including listings provided through IDX (Internet Data Exchange), is deemed reliable but not guaranteed. Listing data is provided for consumers' personal, non-commercial use and may not be used for any purpose other than to identify prospective properties for purchase.",
      "Availability, pricing, and property details are subject to change without notice.",
    ],
  },
  {
    title: "3. No Legal or Financial Advice",
    body: [
      "Content on this website does not constitute legal, financial, tax, or investment advice. You should consult qualified professionals regarding your specific circumstances before making any real estate decision.",
    ],
  },
  {
    title: "4. Intellectual Property",
    body: [
      "All content on this site — including text, design, imagery, and branding — is the property of Scherif Real Estate or its licensors and is protected by applicable intellectual property laws. It may not be reproduced without written permission.",
    ],
  },
  {
    title: "5. Third-Party Links",
    body: [
      "This site may contain links to third-party websites and services, including MLS/IDX providers and virtual tour platforms. We are not responsible for the content, accuracy, or practices of third-party sites.",
    ],
  },
  {
    title: "6. Limitation of Liability",
    body: [
      "To the fullest extent permitted by law, Scherif Real Estate shall not be liable for any indirect, incidental, or consequential damages arising from your use of this website or reliance on its content.",
    ],
  },
  {
    title: "7. Indemnification",
    body: [
      "You agree to indemnify and hold harmless Scherif Real Estate from any claims, damages, or expenses arising out of your misuse of this website or violation of these Terms.",
    ],
  },
  {
    title: "8. Changes to These Terms",
    body: [
      "We may revise these Terms & Conditions at any time. Changes take effect when posted on this page; continued use of the site constitutes acceptance of the revised terms.",
    ],
  },
  {
    title: "9. Governing Law",
    body: [
      "These Terms & Conditions are governed by the laws of the State of Maryland, without regard to its conflict of laws principles.",
    ],
  },
  {
    title: "10. Contact",
    body: ["Questions about these Terms may be directed to:"],
    contact: true,
  },
];

const Terms = () => (
  <>
    <Seo
      title="Terms & Conditions — Scherif Real Estate"
      siteName="Scherif Real Estate"
      description="Terms & Conditions governing the use of the Scherif Real Estate website."
    />
    <section className="container-luxe max-w-4xl pb-28 pt-36 sm:pt-48" data-testid="terms-page">
      <FadeUp>
        <Eyebrow className="mb-5">Legal</Eyebrow>
        <h1 className="font-serif text-5xl font-light tracking-tight text-charcoal sm:text-6xl">Terms &amp; Conditions</h1>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-muted">Scherif Real Estate — Effective Date: 9/10/2025</p>
      </FadeUp>
      <div className="mt-16 space-y-12">
        {SECTIONS.map((s) => (
          <FadeUp key={s.title}>
            <h2 className="font-serif text-2xl font-light text-charcoal sm:text-3xl">{s.title}</h2>
            {s.body.map((p, i) => (
              <p key={i} className="mt-4 text-sm leading-[1.9] text-slate-muted">{p}</p>
            ))}
            {s.contact && (
              <div className="mt-6 border border-warm-border bg-stone-beige p-6">
                <p className="font-serif text-xl text-charcoal">Scherif Real Estate</p>
                <a href="mailto:scherifrealestate@gmail.com" className="link-underline mt-2 inline-block text-sm text-charcoal" data-testid="terms-email">
                  scherifrealestate@gmail.com
                </a>
              </div>
            )}
          </FadeUp>
        ))}
      </div>
    </section>
  </>
);

export default Terms;
